import React from 'react';
import { Reveal } from './Reveal';
import { CtaButton } from './CtaButton';
import { CrossIcon, CheckIcon, FlameIcon } from './icons/Icons';
export function ClosingSection() {
  return <section className="relative w-full overflow-hidden bg-[#1f2a22] py-16 text-white sm:py-24" data-id="element-40">
      <div className="mx-auto max-w-4xl px-5" data-id="element-41">
        <Reveal data-id="element-42">
          <div className="text-center" data-id="element-43">
            <span className="animate-flicker inline-block text-[#ff7b39]" data-id="element-44">
              <FlameIcon className="h-10 w-10" strokeWidth={2} data-id="element-45" />
            </span>
            <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight sm:text-4xl" data-id="element-46">
              Tienes dos opciones ahora mismo
            </h2>
          </div>
        </Reveal>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-47">
          <Reveal delay={0.08} data-id="element-48">
            <div className="flex h-full flex-col rounded-2xl border border-[#7a1e12]/40 bg-[#2a1512]/60 p-6" data-id="element-49">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#7a1e12] text-white" data-id="element-50">
                <CrossIcon className="h-5 w-5" strokeWidth={2.6} data-id="element-51" />
              </span>
              <h3 className="mt-4 font-display text-xl font-bold text-[#ff9a8a]" data-id="element-52">
                Camino A
              </h3>
              <p className="mt-2 text-base leading-relaxed text-white/70" data-id="element-53">
                Seguir comprando antiácidos químicos, durmiendo sentado y
                temiendo a la comida.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.16} data-id="element-54">
            <div className="flex h-full flex-col rounded-2xl border-2 border-[#7fbf74] bg-[#26332a] p-6" data-id="element-55">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#3f6b3a] text-white" data-id="element-56">
                <CheckIcon className="h-5 w-5" strokeWidth={3} data-id="element-57" />
              </span>
              <h3 className="mt-4 font-display text-xl font-bold text-[#7fbf74]" data-id="element-58">
                Camino B
              </h3>
              <p className="mt-2 text-base leading-relaxed text-white/80" data-id="element-59">
                Invertir{' '}
                <span className="font-semibold text-white" data-id="element-60">$10.99</span> (lo que
                gastas en una comida rápida que te daría acidez) y empezar a
                sanar tu estómago desde hoy mismo.
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.24} data-id="element-61">
          <div className="mx-auto mt-10 max-w-lg" data-id="element-62">
            <CtaButton data-id="element-63" />
          </div>
        </Reveal>
      </div>
    </section>;
}